import styled from 'styled-components';
import { Pin, Search, Command } from 'lucide-react';
import Button from '../../../components/Button/Button';
import FramerBlock from '../../../components/FramerBlock/FramerBlock';

const DiscoverSection = () => {
  const handleSignupClick = () => {
    window.open("https://tackoom.com/registration/user", "_blank");
  };

  const handleLoginClick = () => {
    window.open("https://tackoom.com/login", "_blank");
  };

  return (
    <Container>
      <ContainerBox>
        <LeftDivision>
          <FramerBlock />
          <VideoWrapper>
            <StyledVideo controls>
              <source src="https://beta.tackoom.com/Tackoom.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </StyledVideo>
          </VideoWrapper>
        </LeftDivision>

        <RightDivision>
          <h4 className="manrope-bold heading-color">
            Up your counseling hassle, it’s easy
          </h4>

          <div className="list">
            <div className="listIconContainer">
              <Pin />
            </div>
            <div className="listInfo">
              <h6 className="manrope-semibold">No cost to join</h6>
              <SubDesc className="manrope-regular">
                Register and explore counseling opportunities, browse counselor
                profiles, or even book a free consultation.
              </SubDesc>
            </div>
          </div>

          <div className="list">
            <div className="listIconContainer">
              <Search />
            </div>
            <div className="listInfo">
              <h6 className="manrope-semibold">
                Receive the best for your own better self.
              </h6>
              <SubDesc className="manrope-regular">
                Register to access a range of counseling options and get
                personalized guidance from expert counselors.
              </SubDesc>
            </div>
          </div>

          <div className="list">
            <div className="listIconContainer">
              <Command />
            </div>
            <div className="listInfo">
              <h6 className="manrope-semibold">
                Unlock your scholarship without financial stress
              </h6>
              <SubDesc className="manrope-regular">
                Find the perfect scholarship and receive tailored advice from
                top counselors to help you succeed.
              </SubDesc>
            </div>
          </div>

          <div className="list">
            <div className="listIconContainer">
              <Pin />
            </div>
            <div className="listInfo">
              <h6 className="manrope-semibold">No cost to join</h6>
              <SubDesc className="manrope-regular">
                Register and explore scholarship opportunities, browse counselor
                profiles, or even book a free consultation.
              </SubDesc>
            </div>
          </div>

          <div className="btn-container">
            <Button onClick={handleSignupClick}>Signup For Free</Button>
            <Button variant="ghost" onClick={handleLoginClick}>Get Started</Button>
          </div>
        </RightDivision>
      </ContainerBox>
    </Container>
  );
};

export default DiscoverSection;

const SubDesc = styled.p`
  color: #aaaaaa;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const ContainerBox = styled.div`
  width: 100%;
  max-width: 1150px;
  padding: 2.25px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const LeftDivision = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  border-radius: 16px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  background-color: #2a2a2a;
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 240px;
  border-radius: 12px;
  @media (min-width: 768px) {
    height: 300px;
  }
  @media (min-width: 1024px) {
    height: 360px;
  }
`;

const RightDivision = styled.div`
  width: 60%;
  padding-left: 2rem;

  @media (max-width: 768px) {
    width: 100%;
    padding-left: 0rem;
    padding: 1.5rem;
  }

  h4 {
    font-size: 2.7rem;
  }

  .list {
    margin: 1rem 0rem;
    display: flex;
  }

  .listIconContainer {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .listInfo {
    padding-left: 1rem;
    display: flex;
    flex-direction: column;

    h6 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.9rem;
    }
  }

  .btn-container {
    display: flex;
    margin-top: 2rem;

    button {
      margin-right: 1rem;
    }
  }
`;
